import { isMobileOnly } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
//import SkateboardingIcon from '@mui/icons-material/Skateboarding';
import { LaserIcon, MagnifierIcon, TeleportIcon } from '@icons';

import { useMytaverseEvent } from '@core/dashboard/providers';
import { useToolsState } from '../hooks';
import { useMytaverse } from '@providers/MytaverseProvider';

import { ITool } from './interfaces';
import { WebsocketAction } from '@interfaces/webSocketConnectionInfo';
import { FeedbackIcon } from '@icons/FeedbackIcon';
import { shouldShowFeedbackForEvent } from '@core/dashboard/utils/feedbackFormUtils';

export const useHandleToolClick = (onClose: () => void) => {
  const {
    isHoverboardApplied,
    setHoverboard,
    isLaserPointerApplied,
    setLaserPointer,
    isMagnifierApplied,
    setMagnifier,
  } = useToolsState();
  const { sendMessageToUnreal, setShowFeedbackForm } = useMytaverse();
  const { isTeleportingToRoomByUnreal } = useMytaverseEvent();

  const handleClick = (action: WebsocketAction) => {
    if (action === WebsocketAction.Hoverboard) {
      sendMessageToUnreal({
        action,
        state: isHoverboardApplied,
      });
      setHoverboard(!isHoverboardApplied);
      onClose();
      return;
    }

    if (action === WebsocketAction.LaserPointer) {
      sendMessageToUnreal({
        action,
        state: isLaserPointerApplied,
      });
      setLaserPointer(!isLaserPointerApplied);
      onClose();
      return;
    }

    if (action === WebsocketAction.Magnifier) {
      sendMessageToUnreal({
        action,
        state: isMagnifierApplied,
      });
      setMagnifier(!isMagnifierApplied);
      onClose();
      return;
    }

    if (action === WebsocketAction.BeamMeUp) {
      sendMessageToUnreal({
        action,
        state: isTeleportingToRoomByUnreal,
      });
      onClose();
    }

    if (action === WebsocketAction.ShowSurvey) {
      setShowFeedbackForm(true);
    }
  };

  return handleClick;
};

export const useTools = () => {
  const { t: translate } = useTranslation();
  const { teleportEnabled, currentEvent } = useMytaverseEvent();

  const tools: ITool[] = [
    ...(teleportEnabled
      ? [
          {
            icon: TeleportIcon,
            name: translate(
              isMobileOnly ? 'actions.teleport' : 'actions.teleportT',
            ),
            description: translate('actions.teleportDescription'),
            action: WebsocketAction.BeamMeUp,
          },
        ]
      : []),
    // {
    //   icon: SkateboardingIcon,
    //   name: translate('actions.hoverboard'),
    //   description: translate('actions.hoverboardDescription'),
    //   action: WebsocketAction.Hoverboard,
    // },
    {
      icon: LaserIcon,
      name: translate('actions.laserPointer'),
      description: translate('actions.laserPointerDescription'),
      action: WebsocketAction.LaserPointer,
    },
    {
      icon: MagnifierIcon,
      name: translate('actions.magnifier'),
      description: translate('actions.magnifierDescription'),
      action: WebsocketAction.Magnifier,
    },
    ...(shouldShowFeedbackForEvent(currentEvent?.eventTags)
      ? [
          {
            icon: FeedbackIcon,
            name: translate('actions.survey'),
            description: translate('actions.surveyDescription'),
            action: WebsocketAction.ShowSurvey,
          },
        ]
      : []),
  ];

  return tools;
};
